export default __webpack_public_path__ + "static/media/linkedin.1839469b.png";